// @ts-nocheck
/* eslint-disable */

import React from 'react';
import EntityTable from 'app/components/CRUD/EntityTable';
import StyleIcon from '@mui/icons-material/Style';
import moment from 'moment';

const FareMediaBatchesTable: React.FC = () => {
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';

  return (
    <EntityTable
      // ============ PAGE CONFIGURATION ============
      pageTitle="FareMediaBatches"
      pageIcon={StyleIcon}
      addButtonLabel="AddNewFareMediaBatch"

      // ============ NAVIGATION URLs ============
      addPageUrl="/CardsManagement/fare-media-batches/new"
      viewPageUrl="/CardsManagement/fare-media-batches/:id"
      editPageUrl="/CardsManagement/fare-media-batches/:id/edit?came_from=all"

      // ============ API CONFIGURATION ============
      getApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/fare_media_batches`}
      getApiMethod="GET"

      deleteApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/fare_media_batches/:id`}
      deleteApiMethod="DELETE"

      // ============ RESPONSE CONFIGURATION ============
      responseDataPath="data.data.fareMediaBatches"
      responsePaginationPath="data.data.pagination"

      // ============ TABLE CONFIGURATION ============
      idField="fare_media_batches_id"
      columns={[
        {
          field: 'label',
          headerKey: 'BatchLabel',
          align: 'center',
          sortable: true,
          sortField: 'fmb.label',
        },
        {
          field: 'note',
          headerKey: 'Notes',
          align: 'center',
          sortable: true,
          sortField: 'fmb.note',
        },
        {
          field: 'org_en_name',
          headerKey: 'Organisation',
          align: 'center',
          render: (value, row) => (
            currentLanguageCode === 'en-us' ? row.org_en_name : row.org_ar_name
          ),
        },
        {
          field: 'created_at',
          headerKey: 'CreatedAt',
          align: 'center',
          render: (value) => value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '-',
          sortable: true,
          sortField: 'fmb.created_at',
        },
      ]}

      // ============ SEARCH CONFIGURATION ============
      searchQueryParam="search"
      searchPlaceholder="SearchFareMediaBatchPlaceholder"
      searchInputWidth="260px"

      // ============ FILTER CONFIGURATION ============
      filterFields={[
        {
          name: 'organisations_id',
          labelKey: 'Organisation',
          type: 'dropdown',
          apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/faremedia/get_organisations`,
          apiMethod: 'GET',
          dataPath: 'data.data',
          optionConfig: {
            valueField: 'id',
            labelField: (item: any) => currentLanguageCode === 'en-us' ? item.en_name : item.ar_name,
          },
        },
      ]}

      // ============ PERMISSIONS ============
      subsystemName="FareMediaBatches"
      permissionSystem="masterConfig"

      // ============ ACTIONS ============
      showAddButton={true}
      showActions={true}
      showEdit={true}
      showDelete={true}
      deleteConfirmationMessage="AreYouSureDeleteFareMediaBatch"
    />
  );
};

export default FareMediaBatchesTable;
